import Cascader from './base/main';

/* istanbul ignore next */
Cascader.install = function(Vue) {
    Vue.component(Cascader.name, Cascader);
};

export default Cascader;
